import React from "react";

import { Route } from "react-router-dom";

import { FAST_CHANNELS_ROUTE } from "./routes";
import FASTWebSocketProvider from "../../contexts/FASTWebSocketProvider";
import AdBreaks from "../fast_channels/adBreaks/AdBreaks";
import AdBreaksEdit from "../fast_channels/adBreaks/AdBreaksEdit";
import Calendar from "../fast_channels/calendar/Calendar";
import Destinations from "../fast_channels/destinations/Destinations";
import FASTChannelList from "../fast_channels/FASTChannelList";
import FASTLayout from "../fast_channels/FASTLayout";
import FASTPlaylistEdit from "../fast_channels/fastPlaylist/FASTPlaylistEdit";
import FASTPlaylists from "../fast_channels/fastPlaylist/FASTPlaylists";
import Scheduling from "../fast_channels/scheduling/Scheduling";
import SchedulingSettings from "../fast_channels/schedulingSettings/SchedulingSettings";
import Settings from "../fast_channels/settings/Settings";
import TemplateEdit from "../fast_channels/templates/TemplateEdit";
import Templates from "../fast_channels/templates/Templates";
import TimeslotEdit from "../fast_channels/timeslots/TimeslotEdit";
import TimeslotList from "../fast_channels/timeslots/TimeslotList";

import type { JSX } from "react";

export interface FASTChannelRoutesParams {
  channelId: string;
}

function FASTChannelRoutes(): JSX.Element {
  return (
    <React.Fragment>
      <Route exact component={FASTChannelList} path={FAST_CHANNELS_ROUTE} />
      <Route path={`${FAST_CHANNELS_ROUTE}/:channelId`}>
        <FASTWebSocketProvider>
          <FASTLayout>
            <Route
              exact
              component={Destinations}
              path={`${FAST_CHANNELS_ROUTE}/:channelId`}
            />
            <Route
              exact
              component={Calendar}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/calendar`}
            />
            <Route
              exact
              component={Scheduling}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/scheduling`}
            />
            <Route
              exact
              component={SchedulingSettings}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/schedule-settings`}
            />
            <Route
              exact
              component={Settings}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/channel-settings`}
            />
            <Route
              exact
              component={Destinations}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/distribute`}
            />
            <Route
              exact
              component={TimeslotList}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/timeslots`}
            />
            <Route
              exact
              component={TimeslotEdit}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/timeslots/:timeslotId`}
            />
            <Route
              exact
              component={AdBreaksEdit}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/ad-breaks/:adbreakId`}
            />
            <Route
              exact
              component={AdBreaks}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/ad-breaks`}
            />
            <Route
              exact
              component={FASTPlaylists}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/fast-playlists`}
            />
            <Route
              exact
              component={FASTPlaylistEdit}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/fast-playlists/:playlistId`}
            />
            <Route
              exact
              component={Templates}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/templating`}
            />
            <Route
              exact
              component={TemplateEdit}
              path={`${FAST_CHANNELS_ROUTE}/:channelId/templating/:templateId`}
            />
          </FASTLayout>
        </FASTWebSocketProvider>
      </Route>
    </React.Fragment>
  );
}

export default FASTChannelRoutes;
